import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from '@/config/router.config'
import store from '@/store'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior(to: any, from: any, savedPosition: any) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
	routes: constantRouterMap,
})

router.afterEach((to: any) => {
	if (to.meta && to.meta.title) {
		window.document.title = to.meta.title + ' - ' + store.state.app.name
	}
})

export default router
